import {useReducer} from "react";
import reducer from "./reducer";
import CategoryCharityContext, {internalState} from "./context";
import {execute} from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import {ICategoryCharity} from "../../models/category_charity/response";
import {ICreateCategoryCharity, IUpdateCategoryCharity} from "../../models/category_charity/request";
import {ICategoryCharityQuery} from "../../models/category_charity/query";

export interface IProps {
    children: React.ReactNode;
}

const CategoryCharityContextProvider: React.FC<IProps> = (props) => {
    const [state, dispatch] = useReducer(reducer, internalState)

    const getData = async () => {
        await execute({
            callback: async () => {
                dispatch({ type: "LOADING", payload: { loading: "list" } });

                const { data } = await EndPoints.categoryCharity.getAllCategoriesCharities(state.query);

                dispatch({ type: "SET_LIST", payload: { list: data } });
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({ type: "LOADING", payload: { loading: "list" } });
            },
            throwException: false,
        });
    };

    const getDetails = async (id: number) => {
        await execute({
            callback: async () => {
                dispatch({ type: "LOADING", payload: { loading: "details" } });

                const { data } = await EndPoints.categoryCharity.getCategoryCharity(id);
                dispatch({ type: "SET_DETAILS", payload: { details: data } });
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({ type: "LOADING", payload: { loading: "details" } });
            },
            throwException: false,
        });
    };

    const setDetails = async (data?: ICategoryCharity) => {
        // dispatch({ type: 'SET_DETAILSS', payload: { details: data } })
    };

    const createCategoryCharity = async (request: ICreateCategoryCharity) => {
        await execute({
            callback: async () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "create" },
                });

                await EndPoints.categoryCharity.createCategoryCharity(request);
                getData();
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "create" },
                });
            },
            throwException: true,
        });
    };

    const updateCategoryCharity = async (id: number, request: IUpdateCategoryCharity) => {
        await execute({
            callback: async () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "update" },
                });
                await EndPoints.categoryCharity.updateCategoryCharity(id, request);

                getData();
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "update" },
                });
            },
            throwException: true,
        });
    };

    const deleteCategoryCharity = async (id: number) => {
        await execute({
            callback: async () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "delete" },
                });

                await EndPoints.categoryCharity.deleteCategoryCharity(id);

                getData();
            },
            fallback: (error) => {},
            finallyCallback: () => {
                dispatch({
                    type: "LOADING",
                    payload: { loading: "delete" },
                });
            },
            throwException: true,
        });
    };

    const setSearch = (search?: string) => {
        dispatch({ type: "SET_SEARCH", payload: { search } });
    };

    const setQuery = (query: ICategoryCharityQuery) => {
        dispatch({ type: "SET_QUERY", payload: { query } });
    };

return(
    <CategoryCharityContext.Provider
    value={{
        ...state,
        actions: {
            getData,
            getDetails,
            setDetails,

            createCategoryCharity,
            updateCategoryCharity,
            deleteCategoryCharity,

            setSearch,
            setQuery,
        }
    }}
    >
        {props.children}
    </CategoryCharityContext.Provider>
)
}

export default CategoryCharityContextProvider;
